import React from 'react';
import './Intro.css';
import me from '../../images/me.png';
import Header from '../Header/Header';
import Scroll from '../Scroll/Scroll';

const Intro = () => {
    return (
        <div className='all'>
        <Header></Header>
        <div className="i">
           <div className="i-left">
               <div className="i-left-wrapper">
                   <h2 className='i-intro'>Hello! My name is</h2>
                   <h1 className='i-name'><span style={{color:"rgb(1, 57, 61)"}}>Ⓘ</span><span style={{color:"rgb(43 39 39)"}}>srat Zahan Sathi</span></h1>
                   <div className="i-title">
                       <div className="i-tittle-wrapper">
                           <p className="i-title-item"><span className='i-ss g-3'>MERN </span>Stack Web Developer</p>
                           <p className="i-title-item"><span className='i-ss g-3'>Front-end </span>Web Developer</p>
                           <p className="i-title-item"><span className='i-ss'>Lerner</span></p>
                           <p className="i-title-item"><span className='i-ss'> Web</span>Designer</p>
                           <p className="i-title-item"><span className='i-ss'> Computer</span>Engineer</p>
                           <p className="i-title-item">Student</p>
                       </div>
                   </div>
                   <p className="i-decs">
                    I am a MERN Stack Web Developer and have great experience in Front-end development. I build user-friendly, responsive websites and maintain all the following parts like Security, Performance, User friendly, Proper maintainability code.
                   </p>
               </div>
           </div>
           <div className="i-right">
               <div className="i-bg"></div>
               <img src={me} alt="" className="i-img" />
           </div>
        </div>
           <Scroll></Scroll>
        </div>
    );
};

export default Intro;